import { render, staticRenderFns } from "./NextMatch.vue?vue&type=template&id=39115992&scoped=true"
import script from "./NextMatch.vue?vue&type=script&lang=js"
export * from "./NextMatch.vue?vue&type=script&lang=js"
import style0 from "./NextMatch.vue?vue&type=style&index=0&id=39115992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39115992",
  null
  
)

export default component.exports